import { GameErrorCard } from '../../layout/sections/game/GameErrorCard';

type FloatingControlsErrorProps = {
  error: Error;
  resetError: () => void;
};

export default function FloatingControlsError({ error, resetError }: FloatingControlsErrorProps) {
  return (
    <div
      className="fixed right-6 z-40"
      style={{ bottom: 'calc(1.5rem + var(--app-safe-area-bottom))' }}
    >
      <GameErrorCard
        title="Błąd panelu narzędzi"
        message={error.message}
        actionLabel="Spróbuj ponownie"
        onAction={resetError}
        className="p-3 shadow-lg"
        titleClassName="text-xs"
        messageClassName="text-[11px]"
        actionClassName="text-xs"
      />
    </div>
  );
}
